import type { ReactNode } from 'react';

import { DEFAULT_SCOPE_FILTER_STYLES, type ScopeFilterStyles } from './scopeFilterStyles';

export type ScopeFilterRow = {
  key: string;
  label: string;
  indicator?: ReactNode;
  count: number;
  selected: boolean;
  disabled?: boolean;
  testId?: string;
  onToggle: () => void;
};

export const ScopeFilterSection = ({
  rows,
  testId,
  styles = DEFAULT_SCOPE_FILTER_STYLES,
}: {
  rows: readonly ScopeFilterRow[];
  testId?: string;
  styles?: ScopeFilterStyles;
}) => (
  <div css={styles.rows} data-testid={testId}>
    {rows.map(({ key, label, indicator, count, selected, disabled, testId: rowTestId, onToggle }) => {
      const empty = count === 0;
      return (
        <button
          key={key}
          type={'button'}
          disabled={disabled}
          aria-pressed={selected}
          data-testid={rowTestId}
          css={[styles.row, empty && styles.emptyRow, selected && styles.selectedRow]}
          onClick={onToggle}
        >
          {indicator}
          <span css={styles.label}>{label}</span>
          <span css={[styles.count, empty && styles.emptyCount]}>{count}</span>
        </button>
      );
    })}
  </div>
);
